import { observer } from "mobx-react";
import ScenarioTableCard from "./ScenarioTableCard";

const ScenarioView: React.FC = () => {
  return (
    <div className="scenario-container">
      <div className="p-px-3">
        <ScenarioTableCard />
      </div>
    </div>
  );
};

export default observer(ScenarioView);
